import { AtTabs, Tab } from '../../atoms'
import { MlDirections, MlDirectionsProps } from '../../molecules'
import { ImageBody, ImageBodyProps, Section, SectionBody, TextBody, TextBodyProps } from './index.components'
import { OrMapTile, OrMapTileProps } from '../or-map-tile'

export { sectionBorders } from './index.components'

export type FlexibleBlockContent = { description?: string } & (
  | ({ type: 'directions' } & ImageBodyProps & MlDirectionsProps)
  | ({ type: 'text' } & ImageBodyProps & TextBodyProps)
  | ({ type: 'map' } & OrMapTileProps)
)

export interface OrFlexibleBlockProps {
  dataTestId?: string
  title: string
  tabs: (Omit<Tab, 'content'> & {
    content: FlexibleBlockContent
  })[]
  onChange?: (index: number) => void
}

const parseContent = (tabs: OrFlexibleBlockProps['tabs']): Tab[] =>
  tabs.map(({ content, ...tab }) => {
    if (content.type === 'map')
      return {
        ...tab,
        content: (
          <SectionBody description={content.description}>
            <OrMapTile {...content} />
          </SectionBody>
        ),
      }

    return {
      ...tab,
      content: (
        <SectionBody description={content.description}>
          <ImageBody
            aspectRatio={content.aspectRatio}
            images={content.images}
            shortDescription={content.shortDescription}
          />
          {content.type === 'directions' ? (
            <MlDirections directions={content.directions} />
          ) : (
            <TextBody body={content.body} title={content.title} details={content.details} />
          )}
        </SectionBody>
      ),
    }
  })

export const OrFlexibleBlock = ({ tabs, title, onChange, dataTestId = 'or-flexible-block' }: OrFlexibleBlockProps) => {
  const content = parseContent(tabs)
  return (
    <Section data-testid={dataTestId} title={title}>
      {content.length > 1 ? <AtTabs tabs={content} onChange={onChange} /> : content[0].content}
    </Section>
  )
}
